import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ConfirmUser, SendConfirmationEmail} from "@flowmaps-com/flowmaps-typescriptmodels";
import {AuthService} from "../../../utils/auth.service";
import {Handler} from "src/app/common/handler";
import {View} from "src/app/common/view";
import {AppCommonUtils} from "src/app/common/app-common-utils";

@Component({
    selector: 'app-confirm-user',
    templateUrl: './confirm-user.component.html',
    styleUrls: ['./confirm-user.component.css']
})
@Handler()
export class ConfirmUserComponent extends View implements OnInit {
    private route: ActivatedRoute = inject(ActivatedRoute);
    private authService: AuthService = inject(AuthService);

    userId: string;
    token: string;

    ngOnInit(): void {
        this.userId = this.route.snapshot.queryParamMap.get('userId');
        this.token = this.route.snapshot.params['token'];
        if (this.token && this.userId) {
            this.confirmUser();
        }
        if (!this.userId) {
            this.authService.navigateToLogin();
        }
    }

    resendConfirmationEmail() {
        this.sendCommand('com.flowmaps.api.authentication.SendConfirmationEmail', <SendConfirmationEmail>{
            userId: this.userId
        }, () => AppCommonUtils.registerSuccess("Confirmation e-mail sent"))
    }

    confirmUser() {
        this.authService.confirm(<ConfirmUser>{
            userId: this.userId,
            token: this.token
        });
    }
}
